import { ref } from "vue";
import { ModalController } from '../component/Modal/ModalController';

const modalController = ref(new ModalController())

export default function () {
    const methods = {
        getModalController: function () {
            return modalController.value
        }
    }

    return {
        methods
    }
}
